import React from "react";
import { BarChart, Bar, ResponsiveContainer } from "recharts";
import "./style.scss";

const BarMinichart = ({ graphData, dataKey, color }) => {
  let data = [];
  if (graphData && graphData.state === "LOADED" && graphData.value.length > 10) {
    data = graphData.value || [];
  }

  return (
    <div style={{ width: "100px", height: "50px" }}>
      <ResponsiveContainer width={100} height={"100%"}>
        <BarChart width={150} height={40} data={data}>
          <Bar dataKey={dataKey} fill={color} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarMinichart;
